export default "__VITE_ASSET__B86vPouU__"